import "./AnnualBalancesheet.scss";
import AnnualBalancesheetContent from "components/balancesheet/content/AnnualBalancesheetContent";
import { useAnnualBalancesheetContext } from "api/balance-sheet/annual/AnnualBalancesheetProvider";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

const AnnualBalancesheet = () => {
  const {
    getAnnualBalanceSheetByToken,
    annualBalancesheetByToken,
    getAnnualEvaluationById,
    resetAnnualBalancesheetComputedState,
  } = useAnnualBalancesheetContext();
  const { person_id, slug, token } = useParams();

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const evaluation_id = queryParams.get("evaluation_id");
  const isExport = queryParams.get("export") === "true";

  const [personInfo, setPersonInfo] = useState({});
  const [form, setForm] = useState({ fields: [] });

  useEffect(() => {
    resetAnnualBalancesheetComputedState();

    if (token) {
      getAnnualBalanceSheetByToken({ slug, token });
    } else if (person_id && evaluation_id) {
      getAnnualEvaluationById({ person_id, evaluation_id, isExport });
    }
  }, [
    person_id,
    evaluation_id,
    search,
    slug,
    token,
    getAnnualBalanceSheetByToken,
    getAnnualEvaluationById,
    resetAnnualBalancesheetComputedState,
    isExport,
  ]);

  useEffect(() => {
    if (annualBalancesheetByToken) {
      setPersonInfo({
        first_name: annualBalancesheetByToken.person_first_name,
        last_name: annualBalancesheetByToken.person_last_name,
        analytical_code: annualBalancesheetByToken.person_analytical_code,
      });
    }
  }, [annualBalancesheetByToken]);

  return (
    <div
      className={`balancsheet-section balancesheet-responsive-page${
        isExport ? " balancsheet-section--export" : ""
      }`}
    >
      <AnnualBalancesheetContent
        data={annualBalancesheetByToken?.balancesheet}
        form={form}
        setForm={setForm}
        personById={personInfo}
        isExport={isExport}
      />
    </div>
  );
};

export default AnnualBalancesheet;
